// Persistence for half-written posts.
//
// There are TWO compose surfaces, which is easy to miss: CreatePostModal
// (the feed FAB, and "New Topic" from the Tables browse screen) and an inline
// form on the table detail screen with its own state. A draft written in one
// must not surface in the other, so drafts are scoped by key:
//
//   draftKey()                 → the modal; it picks its own table
//   draftKey(`table:${slug}`)  → the inline form on that table
//
// Every access is wrapped. Safari private mode throws on localStorage rather
// than returning null, and a quota error on write must never take down a
// compose screen. AnnouncementCard set the precedent for this.

const PREFIX = 'dspcafe_post_draft';

export const draftKey = (scope) => (scope ? `${PREFIX}:${scope}` : PREFIX);

export function readDraft(key) {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const d = JSON.parse(raw);
    return d && typeof d === 'object' ? d : null;
  } catch {
    return null;
  }
}

// A draft is only worth keeping if it has text in it — a bare table selection
// is not something anyone would miss, and storing it would make the "restored"
// banner appear for an empty form.
export function writeDraft(key, draft) {
  try {
    const hasText = draft?.subject?.trim() || draft?.content?.trim();
    if (!hasText) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, JSON.stringify(draft));
  } catch {
    /* quota or private mode */
  }
}

export function clearDraft(key) {
  try { window.localStorage.removeItem(key); } catch { /* private mode */ }
}
